// ---------------------------------------------------------------------------
// Equipment domain types
// Ported from trusstor_dashboard/shared/interfaces/Equipment/
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// EquipmentTypes
// (from trusstor_dashboard/shared/interfaces/Equipment/IRawEquipment.ts — enum defined inline)
// ---------------------------------------------------------------------------

export enum EquipmentTypes {
	Optics = 'Optics',
	Electricity = 'Electricity',
	PowerTools = 'Power Tools',
	BondingMachinery = 'Bonding Machinery',
	WaterDrainage = 'Water & Drainage',
	PavingTiling = 'Paving & Tiling',
	Welding = 'Welding',
	MovingLifting = 'Moving & lifting',
	Height = 'Height',
	HeavyEquipment = 'Heavy Equipment',
	Safety = 'Safety',
	ScissorsLift = 'Scissors Lift',
}

// ---------------------------------------------------------------------------
// IRawEquipment
// (from trusstor_dashboard/shared/interfaces/Equipment/IRawEquipment.ts)
// ---------------------------------------------------------------------------

export interface IRawEquipment {
	uuid: string;
	batteryLevel: string;
	RSSI: string;
}

// ---------------------------------------------------------------------------
// IStaticEquipment
// (from trusstor_dashboard/shared/interfaces/IStaticEquipment.ts)
// ---------------------------------------------------------------------------

export interface IStaticEquipment {
	company: string;
	serialNumber: string;
	name: string;
	type: EquipmentTypes;
	typeNick: string;
	equipmentId: string;
	projectId: string;
	lastSeenDate: Date;
}

// ---------------------------------------------------------------------------
// IEquipmentReporter
// (from trusstor_dashboard/shared/interfaces/Equipment/IEquipmentReporter.ts)
// Extends IBaseArea (areaId, areaNick)
// ---------------------------------------------------------------------------

export interface IEquipmentReporter {
	areaId: string;
	areaNick: string;
	tagId: string;
	profession: string | null;
	rssi: string;
	timestamp: Date;
	floorId: string;
	floorNick: string;
}

// ---------------------------------------------------------------------------
// IMergedEquipment
// (from trusstor_dashboard/shared/interfaces/Equipment/IMergedEquipment.ts)
// Extends IStaticEquipment, IRawEquipment, IBaseArea, IBaseFloor
// ---------------------------------------------------------------------------

export interface IMergedEquipment extends IStaticEquipment, IRawEquipment {
	// IBaseArea
	areaId: string;
	areaNick: string;
	// IBaseFloor
	floorId: string;
	floorNick: string;
	// Own fields
	name: string;
	type: EquipmentTypes;
	typeNick: string;
	reporters: IEquipmentReporter[];
	reporterTagIds: string[];
	unSureLocationCounter?: number;
}

// ---------------------------------------------------------------------------
// IMergedEquipmentView
// (from trusstor_dashboard/shared/interfaces/Equipment/IMergedEquipmentView.ts)
// Extends Omit<IMergedEquipment, 'lastSeenDate'> with optional lastSeenDate
// ---------------------------------------------------------------------------

export interface IMergedEquipmentView extends Omit<IMergedEquipment, 'lastSeenDate'> {
	reporterTagIds: string[];
	lastSeenDate?: Date;
}
